export default {
      id: "location-pin-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "sprite.svg#location-pin",
      toString: function () {
        return this.url;
      }
    }